import useTypedTranslation from '@hooks/useTypedTranslation'

import useShelfSourceText from './useShelfSourceText'

import type { Shelf } from '@state/shelf/types'

/** Where a shelf's data comes from, in the day view. Always shown, including on same-day shelves. */
function ShelfSourceLine({ shelf }: { shelf: Shelf }) {
  const { t } = useTypedTranslation()
  const sourceText = useShelfSourceText(shelf)

  if (!sourceText) return null

  return (
    <div className='px-6 text-right text-xs text-tertiary' data-testid='shelf-source-line'>
      <p>{sourceText}</p>
      {shelf.dayState === 'notCurrent' && <p>{t('storeMap.shelf.source.notCurrent')}</p>}
    </div>
  )
}

export default ShelfSourceLine
